import Cookie from 'js-cookie';

const IPV4_HOSTNAME_PATTERN = /^\d{1,3}(?:\.\d{1,3}){3}$/;

export const getRootDomainCookieOptions = (
  overrides?: Cookie.CookieAttributes,
): Cookie.CookieAttributes => {
  const { hostname } = globalThis.location;
  const domainParts = hostname.split('.').filter(Boolean);
  const isIpv4Hostname = IPV4_HOSTNAME_PATTERN.test(hostname);
  const isLocalhost = hostname === 'localhost';
  const shouldUseHostOnlyCookie =
    isIpv4Hostname || (domainParts.length < 2 && !isLocalhost);
  const rootDomain =
    shouldUseHostOnlyCookie || isLocalhost
      ? hostname
      : domainParts.slice(-2).join('.');

  return {
    sameSite: 'None',
    secure: true,
    ...(shouldUseHostOnlyCookie
      ? {}
      : {
          domain: isLocalhost ? 'localhost' : `.${rootDomain}`,
        }),
    ...overrides,
  };
};

const setSameSiteCookieWithoutExpiry = (key: string, value: string) => {
  Cookie.set(key, value, getRootDomainCookieOptions({ expires: 365 }));
};

export const deleteCookie = (key: string) => {
  Cookie.remove(key, getRootDomainCookieOptions());
};

export default setSameSiteCookieWithoutExpiry;
